/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { RequestStatusLog } from '../models/RequestStatusLog';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class RequestStatusLogService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestId
     * @returns RequestStatusLog
     * @throws ApiError
     */
    public requestStatusLogGetTravelRequestLogs(
        requestId: number,
    ): Observable<Array<RequestStatusLog>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requeststatuslogs/travel/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns RequestStatusLog
     * @throws ApiError
     */
    public requestStatusLogGetReimbursementRequestLogs(
        requestId: number,
    ): Observable<Array<RequestStatusLog>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requeststatuslogs/reimbursement/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns RequestStatusLog
     * @throws ApiError
     */
    public requestStatusLogGetStipendRequestLogs(
        requestId: number,
    ): Observable<Array<RequestStatusLog>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requeststatuslogs/stipend/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
}
